import { render, staticRenderFns } from "./possessiva-pronomen.vue?vue&type=template&id=52eb13dc&scoped=true"
import script from "./possessiva-pronomen.vue?vue&type=script&lang=js"
export * from "./possessiva-pronomen.vue?vue&type=script&lang=js"
import style0 from "./possessiva-pronomen.vue?vue&type=style&index=0&id=52eb13dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb13dc",
  null
  
)

export default component.exports